module.exports = __webpack_public_path__ + "static/media/pic4.59edeffa.jpg";